// extracted by mini-css-extract-plugin
export default {"Chat":"style_Chat__-YcEM","Header":"style_Header__6XPN+","Header-ContactData":"style_Header-ContactData__1YNbI"};